import { createContext, useContext } from "react";

type SupportChatContextValue = {
  isOpen: boolean;
  openSupportChat: () => void;
  closeSupportChat: () => void;
  /** Unread replies from the team, for badging the entry point while the panel is closed. */
  unreadCount: number;
};

export const SupportChatContext = createContext<SupportChatContextValue | null>(null);

/**
 * Both the sidebar footer button and the Help page open the same single chat panel, so the
 * open state lives above them rather than in either one.
 */
export const useSupportChatPanel = () => {
  const context = useContext(SupportChatContext);

  if (!context) {
    throw new Error("useSupportChatPanel must be used within a SupportChatProvider");
  }

  return context;
};
